/*
 * @Author: 吴文洁
 * @Date: 2019-09-06 09:51:29
 * @LastEditors: yujianhui
 * @LastEditTime: 2021-11-04 10:53:31
 * @Description: 
 */
export default {
  routes: [
    {
      path: '/benefits/list',
      name: 'benefits_list',
      component: () => import('@/module/benefits/BenefitsListsPage.vue'),
      meta: {
        title: '优惠福利',
        keepAlive: false,
        logined: true
      }
    },
    {
      path: '/benefits/coupon_manage',
      name: 'coupon_manage',
      component: () => import('@/module/benefits/CouponManagePage.vue'),
      meta: {
        title: '优惠券',
        keepAlive: false,
        logined: true
      }
    },
    {
      path: '/benefits/coupon_share/:id',
      name: 'coupon_share',
      component: () => import('@/module/benefits/CouponSharePage.vue'),
      meta: {
        title: '优惠券详情',
        keepAlive: false,
        logined: false
      }
    },
    {
      path: '/benefits/coupon_add_success', //微信领取成功
      name: 'coupon_add_success',
      component: () => import('@/module/benefits/CouponAddSuccessPage.vue'),
      meta: {
        title: '优惠券领取成功',
        keepAlive: false,
        logined: false
      }
    },
    {
      path: '/instAct/joined/list',
      name: 'instAct_joined_list',
      component: () => import('@/module/benefits/InstActJoinedList.vue'),
      meta: {
        title: '已参加的小麦秀',
        keepAlive: false,
        logined: true
      }
    },
    {
      path: '/shareAct/joined/list',
      name: 'shareAct_joined_list',
      component: () => import('@/module/benefits/ShareActJoinedList.vue'),
      meta: {
        title: '已参加的分享活动',
        keepAlive: false,
        logined: true
      }
    },
    {
      path: '/examAct/joined/list',
      name: 'examAct_joined_list',
      component: () => import('@/module/exam/ExamList.vue'),
      meta: {
        title: '已参加的比赛考级活动',
        keepAlive: false,
        logined: true
      }
    }
  ]
}


// WEBPACK FOOTER //
// ./src/router/Benefit.js